import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(activites)/activities/[country]/[city]/[activityId]/(detailPage)/NewComponents/HotelBill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(details)/header.tsx");
